<template>
  <div class="wrapper ion-text-center">
    <div class="img-wrapper">
      <ion-img :src="drawerFill" alt="drawer" />
    </div>
    <div class="ion-margin-top ion-margin-bottom">
      <ion-label>{{ boardingLabel }}</ion-label>
    </div>
    <div v-for="(item, idx) in steps" :key="idx" class="text-center mt-1">
      <ion-text
        class="ion-text-center fw-600"
        :color="currentStep === item.step ? 'primary' : currentStep === 2 && idx === 0 ? 'grey' : 'dark'"
      >
        <ion-icon v-if="currentStep === item.step" :icon="arrowForwardOutline" color="primary"></ion-icon>
        {{ item.title }}
      </ion-text>
    </div>
    <ion-button :fill="btnFill" class="ion-margin-top" @click="onAction">
      <ion-icon v-if="currentStep === 1" :icon="addOutline" color="light"></ion-icon>
      {{ btnWording }}
      <ion-icon style="margin-left: 10px" v-if="currentStep === 2" :icon="wa"></ion-icon>
    </ion-button>
    <ion-text @click="$emit('refreshAct')" class="ion-text-center fw-500 center-align" color="primary">
      <ion-icon :icon="refresh_icon"></ion-icon>
      {{ $t('refresh') }}
    </ion-text>
  </div>
</template>
<script>
import drawer_not_found from '@/assets/icons/shared/drawer_not_found.svg';
import drawer_welcome from '@/assets/icons/shared/drawer_welcome.svg';
import refresh_icon from '@/assets/icons/shared/refresh.svg';
import wa from '@/assets/icons/shared/wa.svg';
import { addOutline, arrowForwardOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BoardingState',
  props: {
    currentStep: {
      type: Number,
      default: 1
    }
  },
  emits: ['refreshAct'],
  setup() {
    return {
      drawer_not_found,
      drawer_welcome,
      arrowForwardOutline,
      addOutline,
      refresh_icon,
      wa
    };
  },
  data() {
    return {
      steps: [
        {
          step: 1,
          title: this.$t('step1_add_company')
        },
        {
          step: 2,
          title: this.$t('step2_we_will_review')
        },
        {
          step: 3,
          title: this.$t('step3_start_ordering')
        }
      ]
    };
  },
  computed: {
    drawerFill() {
      return this.currentStep === 1 ? drawer_welcome : drawer_not_found;
    },
    boardingLabel() {
      return this.currentStep === 1 ? this.$t('let_us_get_started') : this.$t('we_are_reviewing_company');
    },
    btnWording() {
      return this.currentStep === 1 ? this.$t('add_new_company') : this.$t('contact_us');
    },
    btnFill() {
      return this.currentStep === 1 ? 'solid' : 'outline';
    }
  },
  methods: {
    onAction() {
      this.currentStep === 1
        ? this.$router.push('/b2b/customers/add/no-companies')
        : window.open('https://wa.me/6589541906', '_blank');
    }
  }
});
</script>
<style lang="scss" scoped>
.wrapper {
  width: 85%;
  margin: 0 auto;
  top: 20%;
  position: relative;
  .img-wrapper {
    width: 50%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

.text-center {
  text-align: center;
}
ion-label {
  font-size: 1.2rem;
  color: #000;
  font-weight: bold;
}
ion-button {
  border-radius: 10px;
  text-transform: none;
  width: 100%;
}

ion-icon {
  font-size: 20px;
  margin-bottom: -5px;
}
.center-align {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
</style>
